import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { ResponsiveContainer } from 'recharts';
import { tokens } from "../../../theme";

const ChartCard = ({ title, children, height = 300 }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Paper
            sx={{
                p: 2,
                display: 'flex',
                direction: 'column',
                height: '100%',
                bgcolor: colors.primary[400],
                borderRadius: '8px',
                border: `1px solid ${colors.grey[800]}`
            }}
            elevation={0}
        >
            <Typography variant="h6" fontWeight="bold" mb={2} color={colors.grey[100]}>
                {title}
            </Typography>
            <Box height={height} width="100%">
                <ResponsiveContainer width="100%" height="100%">
                    {children}
                </ResponsiveContainer>
            </Box>
        </Paper>
    );
};

export default ChartCard;
